"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MessageItem = exports.MessageEmojiReact = exports.MessageTool = exports.MessageSystem = exports.MessageRevoked = exports.MessageBubble = exports.MessageTimestamp = exports.MessageTip = exports.MessageCustom = exports.MessageMerger = exports.MessageLocation = exports.MessageFace = exports.MessageFile = exports.MessageAudio = exports.MessageVideo = exports.MessageImage = exports.MessageText = void 0;
var message_text_vue_1 = require("./message-text.vue");
exports.MessageText = message_text_vue_1.default;
var message_image_vue_1 = require("./message-image.vue");
exports.MessageImage = message_image_vue_1.default;
var message_video_vue_1 = require("./message-video.vue");
exports.MessageVideo = message_video_vue_1.default;
var message_audio_vue_1 = require("./message-audio.vue");
exports.MessageAudio = message_audio_vue_1.default;
var message_file_vue_1 = require("./message-file.vue");
exports.MessageFile = message_file_vue_1.default;
var message_face_vue_1 = require("./message-face.vue");
exports.MessageFace = message_face_vue_1.default;
var message_location_vue_1 = require("./message-location.vue");
exports.MessageLocation = message_location_vue_1.default;
var message_merger_vue_1 = require("./message-merger.vue");
exports.MessageMerger = message_merger_vue_1.default;
var message_custom_vue_1 = require("./message-custom.vue");
exports.MessageCustom = message_custom_vue_1.default;
var message_tip_vue_1 = require("./message-tip.vue");
exports.MessageTip = message_tip_vue_1.default;
var message_bubble_vue_1 = require("./message-bubble.vue");
exports.MessageBubble = message_bubble_vue_1.default;
var message_revoked_vue_1 = require("./message-revoked.vue");
exports.MessageRevoked = message_revoked_vue_1.default;
var message_system_vue_1 = require("./message-system.vue");
exports.MessageSystem = message_system_vue_1.default;
var message_tool_vue_1 = require("./message-tool.vue");
exports.MessageTool = message_tool_vue_1.default;
var message_emoji_react_vue_1 = require("./message-emoji-react.vue");
exports.MessageEmojiReact = message_emoji_react_vue_1.default;
var index_vue_1 = require("./index.vue");
exports.MessageItem = index_vue_1.default;
var message_timestamp_vue_1 = require("./message-timestamp.vue");
exports.MessageTimestamp = message_timestamp_vue_1.default;
